<template lang="pug">
div
  v-data-table(
    :headers="headers"
    :items="list"
    hide-default-footer
    :loading="loading"
    class="app-table"
  )
    template(v-slot:item="{item, select, isSelected, index, expand, isExpanded}")
      tr
        td(:class="{'archived': item.isArchived}") {{ item.createdAt | formattedDatetime }} / {{ item.paidAt | formattedDatetime }}
        td(:class="{'archived': item.isArchived}") {{ item.label }} {{ item.amount }}
        td(:class="{'archived': item.isArchived}") {{ item.status }}
        td(:class="{'archived': item.isArchived}") 
          slot(name="actions" :payment="item")

</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      required: true
    },
    loading: Boolean
  },
  
  data:() => ({
    headers: [
      { text: 'Created / Paid', value: 'dates', sortable: false },
      { text: 'Amount', value: 'amount', sortable: false },
      { text: 'Status', value: 'status', sortable: false },
      { text: '', value: 'action', sortable: false}
    ]
  })
}
</script>

<style lang="scss" scoped>
.app-table .archived {
  color: $log-default;
}
</style>